<template>
  <v-container>
    <h3 class="display-2 text-center">Development areas</h3>
    <div class="d-flex">
      <v-btn class="link" color="primary" rounded v-bind:to="{ name: 'test-form' }">Test Image Upload</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  mounted() {},
  methods: {},
};
</script>

<style scoped>
h3 {
  margin-bottom: 20px;
}
.link {
  margin: auto;
}
</style>
